// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/app.scss
// module id = Vp6e
// module chunks = 1